export default "__VITE_ASSET__CaUYJfAp__"